import { Button } from "@progress/kendo-react-buttons";
import { GridCellProps } from "@progress/kendo-react-grid";
import { useNavigate } from "react-router-dom";
import { UserPermissions, UserRoles } from "../../utilities/userUtilities";
import { DeletePopup } from "../quotes";

export interface QuoteActionsProps {
  cellProps: GridCellProps;
  action: string;
  permissions: UserPermissions;
  roles: UserRoles;
  onActionClick: (action: string) => void;
  onCopy: (quote: any) => void;
  onEdit: (quote: any) => void;
  onDelete: (quoteId: number) => void;
  onQuote: (quoteId: number, productType: string) => void;
}

export const QuoteActionsCell = (props: QuoteActionsProps) => {
  const {
    cellProps,
    action,
    permissions,
    roles,
    onActionClick,
    onCopy,
    onEdit,
    onDelete,
    onQuote,
  } = props;
  const { dataItem } = cellProps;
  const disabled = action.length > 0;
  const navigate = useNavigate();

  const isActionable = dataItem.configurationEnabled;
  const showReviewButton =
    dataItem.status === "Pending" &&
    !dataItem.isExpired &&
    permissions.canApproveTrades &&
    roles.isRiskTaker;
  const showDeleteButton = dataItem.status === "Open";

  return (
    <td>
      <div style={{ display: "flex" }}>
        {isActionable && (
          <Button
            disabled={disabled}
            icon="copy"
            themeColor="primary"
            fillMode="outline"
            title="Copy Quote"
            size="small"
            onClick={() => onCopy(dataItem)}
          />
        )}

        {dataItem.status === "Open" && isActionable && (
          <>
            <Button
              disabled={disabled}
              icon="pencil"
              size="small"
              themeColor="primary"
              fillMode="outline"
              title="Edit Quote"
              onClick={() => {
                onActionClick("edit");
                onEdit(dataItem);
              }}
            />

            {dataItem.isValid && (
              <Button
                disabled={disabled}
                icon="arrow-rotate-cw"
                size="small"
                themeColor="primary"
                fillMode="outline"
                title="Refresh Quote"
                onClick={async () => {
                  onActionClick("requote");
                  await onQuote(dataItem.quoteId, dataItem.productType);
                  onActionClick("");
                }}
              />
            )}
          </>
        )}

        {showReviewButton && (
          <Button
            disabled={disabled}
            icon="check"
            size="small"
            themeColor="primary"
            fillMode="outline"
            title="Review Quote"
            onClick={() => navigate(`/quote/details/${dataItem.quoteId}`)}
          />
        )}

        {showDeleteButton && (
          <DeletePopup
            action={action}
            position={"left"}
            data={{ quoteId: dataItem.quoteId }}
            onOpen={onActionClick}
            onClose={() => onActionClick("")}
            onConfirm={() => onDelete(dataItem.quoteId)}
          />
        )}
      </div>
    </td>
  );
};
